import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Rumioncarhire() {



    const cardData = {

keyword: "Rumion Car Hire in Pune",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Rumion Car Hire in Pune for family trips, airport transfers, corporate travel, city rides, and outstation journeys. The Toyota Rumion is a spacious 7-seater vehicle designed for smooth comfort, fuel efficiency, and modern interiors. Our service includes well-maintained cars, experienced chauffeurs, doorstep pickup across Pune, flexible rental options, one-way and round-trip packages, 24/7 availability, and transparent pricing, ensuring a safe and hassle-free travel experience for small families and groups.",

topPlaces: [
 {
        title: "Shirdi Sai Baba Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in Maharashtra dedicated to Sai Baba. Rumion car hire is a comfortable option for family darshan trips, ensuring a smooth highway journey from Pune with sufficient seating and luggage space."
    },
    {
        title: "Nashik & Trimbakeshwar Jyotirlinga",
        description:
            "Nashik is a spiritual city known for Trimbakeshwar Jyotirlinga, Panchavati temples, and vineyards. Rumion is ideal for small group travel combining pilgrimage and leisure trips from Pune with comfort and fuel-efficient travel."
    },
       {
        title: "Lonavala & Khandala Hill Station",
        description:
            "Lonavala and Khandala are the most popular weekend getaways near Pune, known for lush green valleys, waterfalls, and scenic viewpoints. Rumion car hire is ideal for small families and groups who want a comfortable and fuel-efficient ride for short hill station trips and relaxing monsoon drives."
    },
    {
        title: "Mahabaleshwar & Panchgani Tour",
        description:
            "Mahabaleshwar and Panchgani are famous hill stations known for strawberries, viewpoints, lakes, and cool climate. Rumion offers a smooth and spacious travel experience for families exploring nature, sightseeing spots, and peaceful hill station environments from Pune."
    },
    
    {
        title: "Pune Airport Transfers",
        description:
            "Rumion is a great option for Pune airport pickup and drop services due to its spacious seating and comfortable ride quality. It ensures timely transfers for families and business travelers with luggage convenience."
    },
    {
        title: "Alibaug Beach Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches and forts. Rumion is perfect for family weekend trips and beach vacations from Pune, offering comfort and relaxed travel throughout the journey."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by forests. Rumion provides a safe and comfortable travel option for devotees and nature lovers traveling from Pune for spiritual visits."
    },
    {
        title: "Ashtavinayak Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Rumion is suitable for small family spiritual tours, offering comfort, convenience, and smooth travel from Pune."
    },
    {
        title: "Lavasa Hill City Visit",
        description:
            "Lavasa is a scenic planned hill city near Pune known for lakeside views and architecture. Rumion is ideal for short family trips and leisure drives with a comfortable and enjoyable travel experience."
    },
    {
        title: "Outstation Budget Travel",
        description:
            "Rumion car hire is a cost-effective option for outstation travel from Pune, offering good mileage, comfort, and space for short and medium-distance family trips across Maharashtra."
    }
],



services: [
{
name: "Rumion Car on Rent in Pune",
description: "Rising Cab Service offers Rumion Car on Rent in Pune for family trips, airport transfers, corporate travel, sightseeing tours, and outstation journeys. The Toyota Rumion is a spacious and comfortable 7-seater vehicle ideal for group travel, offering ample luggage space, air-conditioned comfort, and smooth performance. We provide professional drivers, affordable rental packages, doorstep pickup, and 24x7 booking support for a safe and enjoyable travel experience."
},
{
name: "6 Seater Car on Rent in Pune",
description: "Book a 6 Seater Car on Rent in Pune with Rising Cab Service for comfortable family travel, business trips, and local sightseeing. Our well-maintained vehicles provide spacious seating, AC comfort, and professional chauffeur service for short and long-distance travel."
},
{
name: "Rumion Cab on Rent in Pune",
description: "Rising Cab Service provides Rumion Cab on Rent in Pune with experienced drivers, clean interiors, and affordable pricing. Whether you need local transportation, airport transfers, or outstation travel, our Toyota Rumion cabs ensure a smooth and comfortable journey."
},
{
name: "Rumion Car Hire in Pimpri Chinchwad",
description: "Choose Rumion Car Hire in Pimpri Chinchwad for reliable and comfortable transportation. Our spacious Toyota Rumion vehicles are ideal for family outings, business travel, airport pickups, and weekend trips."
},
{
name: "Rumion Cab Service in Pune",
description: "Rising Cab Service offers Rumion Cab Service in Pune with flexible rental options, professional chauffeurs, and comfortable travel arrangements. Perfect for local travel, city tours, and outstation journeys."
},
{
name: "Rumion Car Hire in Pune Contact Number",
description: "Book Rumion Car Hire in Pune through Rising Cab Service for quick reservations, transparent pricing, and dependable transportation. We offer easy booking assistance and dedicated customer support."
},
{
name: "Pune Airport Toyota Rumion Cab",
description: "Our Pune Airport Toyota Rumion Cab service provides timely airport pickups and drop-offs with spacious seating, luggage capacity, and professional drivers for a hassle-free travel experience."
},
{
name: "Pune to Mahabaleshwar Rumion Taxi Fare",
description: "Get affordable Pune to Mahabaleshwar Rumion Taxi Fare with Rising Cab Service. Enjoy comfortable hill station travel in a spacious Toyota Rumion with transparent pricing and experienced drivers."
},
{
name: "Pune to Mahabaleshwar Rumion Cabs",
description: "Book Pune to Mahabaleshwar Rumion Cabs for family vacations, weekend trips, and sightseeing tours. Our vehicles offer comfortable seating, AC interiors, and reliable long-distance travel."
},
{
name: "Pune Cab Service Outstation",
description: "Rising Cab Service provides Pune Cab Service Outstation with Toyota Rumion and other vehicle options for convenient travel to destinations across Maharashtra and neighboring states."
},
{
name: "7 Seater Cab in Pune",
description: "Hire a 7 Seater Cab in Pune for family tours, airport transfers, pilgrimages, and group travel. Our Toyota Rumion cabs provide spacious seating, luggage space, and comfortable transportation."
},
{
name: "7 Seater Cab in Pimpri Chinchwad",
description: "Book a 7 Seater Cab in Pimpri Chinchwad for local and outstation travel with professional drivers, clean vehicles, and affordable fares suitable for families and groups."
},
{
name: "7 Seater Cab in Lohegaon Airport Pune",
description: "Our 7 Seater Cab in Lohegaon Airport Pune service ensures convenient airport transfers with ample luggage space, comfortable seating, and timely pickups and drop-offs."
},
{
name: "Pune Airport Cab Service",
description: "Rising Cab Service offers Pune Airport Cab Service with Toyota Rumion vehicles for reliable airport transportation, flight tracking support, and comfortable travel."
},
{
name: "Toyota Rumion Rental Pune",
description: "Toyota Rumion Rental Pune provides spacious and economical transportation for family vacations, corporate travel, airport transfers, and outstation trips with professional chauffeur service."
},
{
name: "Toyota Rumion Cab Service Pune",
description: "Choose Toyota Rumion Cab Service Pune for comfortable and dependable transportation. We offer local, airport, and outstation travel packages with experienced drivers and clean vehicles."
},
{
name: "Rumion Taxi Booking Pune",
description: "Rumion Taxi Booking Pune allows instant reservations with transparent pricing, multiple travel options, and 24x7 customer support for all your transportation needs."
},
{
name: "Rumion Car Rental Pune",
description: "Book Rumion Car Rental Pune for comfortable family travel, sightseeing tours, corporate transportation, and long-distance journeys with reliable service and affordable pricing."
},
{
name: "Rumion Cab Hire Pune",
description: "Rising Cab Service offers Rumion Cab Hire Pune with flexible rental packages, professional chauffeurs, and well-maintained vehicles for local and outstation travel."
},
{
name: "Rumion Car Hire Pune",
description: "Rumion Car Hire Pune provides convenient transportation solutions for families, tourists, and business travelers seeking spacious and comfortable travel options."
},
{
name: "Rumion Outstation Cab Pune",
description: "Book Rumion Outstation Cab Pune for destinations such as Mahabaleshwar, Shirdi, Lonavala, Nashik, Goa, and Mumbai with comfortable seating and safe long-distance travel."
},
{
name: "Rumion Airport Cab Pune",
description: "Rumion Airport Cab Pune offers punctual airport pickups and drop-offs with spacious luggage capacity, comfortable seating, and professional chauffeur support."
},
{
name: "Rumion One Way Cab Pune",
description: "Choose Rumion One Way Cab Pune for affordable drop-only transportation with transparent pricing, clean vehicles, and experienced drivers."
},
{
name: "Rumion Round Trip Cab Pune",
description: "Rumion Round Trip Cab Pune provides flexible return travel options, waiting facilities, and comfortable transportation for business trips, vacations, and sightseeing tours."
},
{
name: "Rumion AC Cab Pune",
description: "Rumion AC Cab Pune offers air-conditioned comfort for local travel, airport transfers, and outstation journeys with professional drivers and affordable fares."
},
{
name: "Online Rumion Booking Pune",
description: "Online Rumion Booking Pune allows easy reservations, instant confirmations, and secure booking support for local and outstation travel requirements."
},
{
name: "Rumion Family Cab Pune",
description: "Rumion Family Cab Pune is ideal for family vacations, religious tours, and group travel, providing spacious seating, comfort, and reliable transportation."
},
{
name: "Rumion 7 Seater Rental Pune",
description: "Book Rumion 7 Seater Rental Pune for family outings, airport travel, sightseeing, and outstation trips with spacious interiors and affordable rental packages."
},
{
name: "Rumion Tourist Cab Pune",
description: "Rumion Tourist Cab Pune offers comfortable transportation for sightseeing tours, holiday travel, and weekend getaways with professional chauffeur service."
},
{
name: "Rumion On Rent in Hinjewadi Pune",
description: "Rising Cab Service provides Rumion On Rent in Hinjewadi Pune for IT professionals, airport transfers, family travel, and outstation journeys with flexible rental plans."
},
{
name: "Rumion On Rent in Kharadi Pune",
description: "Book Rumion On Rent in Kharadi Pune for comfortable and reliable transportation with experienced drivers and affordable travel packages."
},
{
name: "Rumion On Rent in Hadapsar Pune",
description: "Rumion On Rent in Hadapsar Pune is available for airport transfers, corporate travel, family outings, and outstation trips with well-maintained vehicles."
},
{
name: "Rumion On Rent in Baner Pune",
description: "Choose Rumion On Rent in Baner Pune for local and outstation travel with spacious seating, AC comfort, and professional chauffeur support."
},
{
name: "Rumion On Rent in Wakad Pune",
description: "Rumion On Rent in Wakad Pune offers convenient transportation for family tours, business travel, and airport transfers with reliable service."
},
{
name: "Rumion On Rent in Pimpri Chinchwad",
description: "Book Rumion On Rent in Pimpri Chinchwad for comfortable group travel, sightseeing tours, and outstation journeys with affordable rental plans."
},
{
name: "Rumion On Rent in Viman Nagar Pune",
description: "Rumion On Rent in Viman Nagar Pune provides premium transportation solutions for airport transfers, corporate travel, and family trips."
},
{
name: "Rumion On Rent in Kothrud Pune",
description: "Rising Cab Service offers Rumion On Rent in Kothrud Pune with comfortable seating, professional drivers, and flexible booking options."
},
{
name: "Rumion On Rent in Magarpatta Pune",
description: "Book Rumion On Rent in Magarpatta Pune for local travel, airport transfers, and long-distance journeys with dependable service and affordable pricing."
},
{
name: "Rumion On Rent in Wagholi Pune",
description: "Rumion On Rent in Wagholi Pune is available for family vacations, corporate travel, sightseeing tours, and airport transportation with professional chauffeur support."
}
],

tableData: [
["Rumion Car on Rent in Pune","6 Seater Car on Rent in Pune"],
["Rumion Cab on Rent in Pune","Rumion Car Hire in Pimpri Chinchwad"],
["Rumion Cab Service in Pune","Rumion Car Hire in Pune Contact Number"],
["Pune Airport Toyota Rumion Cab","Pune to Mahabaleshwar Rumion Taxi Fare"],
["Pune to Mahabaleshwar Rumion Cabs","Pune Cab Service Outstation"],
["7 Seater Cab in Pune","7 Seater Cab in Pimpri Chinchwad"],
["7 Seater Cab in Lohegaon Airport Pune","Pune Airport Cab Service"],
["Toyota Rumion Rental Pune","Toyota Rumion Cab Service Pune"],
["Rumion Taxi Booking Pune","Rumion Car Rental Pune"],
["Rumion Cab Hire Pune","Rumion Car Hire Pune"],
["Rumion Outstation Cab Pune","Rumion Airport Cab Pune"],
["Rumion One Way Cab Pune","Rumion Round Trip Cab Pune"],
["Rumion AC Cab Pune","Online Rumion Booking Pune"],
["Rumion Family Cab Pune","Rumion 7 Seater Rental Pune"],
["Rumion Tourist Cab Pune","Rumion On Rent in Hinjewadi Pune"],
["Rumion On Rent in Kharadi Pune","Rumion On Rent in Hadapsar Pune"],
["Rumion On Rent in Baner Pune","Rumion On Rent in Wakad Pune"],
["Rumion On Rent in Pimpri Chinchwad","Rumion On Rent in Viman Nagar Pune"],
["Rumion On Rent in Kothrud Pune","Rumion On Rent in Magarpatta Pune"],
["Rumion On Rent in Wagholi Pune","Rumion Outstation Cab Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Rumion Car Hire in Pune",
        WhyChoosedescription: "Rising Cab Service provides Toyota Rumion rental services in Pune for family trips, airport transfers, corporate travel, outstation tours, and weekend getaways."
    },
    {
        WhyChooseheading: "Premium 7 Seater Family Vehicle",
        WhyChoosedescription: "Toyota Rumion is a spacious 7-seater MPV designed for comfortable family travel, offering ample seating space and luggage capacity for long journeys."
    },
    {
        WhyChooseheading: "Ideal for Local and Outstation Travel",
        WhyChoosedescription: "Book a Rumion for Pune city travel or outstation destinations such as Mumbai, Shirdi, Mahabaleshwar, Goa, Nashik, Kolhapur, Lonavala, and Konkan tours."
    },
    {
        WhyChooseheading: "Spacious Cabin with Modern Features",
        WhyChoosedescription: "Passengers enjoy comfortable seating, rear AC vents, spacious interiors, and a smooth ride experience suitable for both short and long-distance travel."
    },
    {
        WhyChooseheading: "Perfect for Airport and Corporate Transfers",
        WhyChoosedescription: "Toyota Rumion is widely preferred for Pune Airport transfers, Mumbai Airport travel, executive transportation, client visits, and business tours."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Rumion pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Safe and Comfortable Long-Distance Travel",
        WhyChoosedescription: "The Rumion offers excellent ride quality, spacious seating for seven passengers, and modern safety features, making it ideal for family road trips. :contentReference[oaicite:0]{index=0}"
    },
    {
        WhyChooseheading: "Professional Drivers and Well-Maintained Vehicles",
        WhyChoosedescription: "Our experienced drivers and regularly serviced Rumion vehicles ensure punctual service, safe journeys, and a hassle-free travel experience."
    }
]
};

const faqData = [
    {
        question: "Why should I hire a Toyota Rumion in Pune?",
        answer: "Toyota Rumion is a spacious 7-seater MPV that offers comfort, luggage space, and smooth performance, making it ideal for family and group travel."
    },
    {
        question: "How many passengers can travel in a Toyota Rumion?",
        answer: "Toyota Rumion comfortably accommodates up to seven passengers with three-row seating. :contentReference[oaicite:1]{index=1}"
    },
    {
        question: "Can I hire a Rumion for outstation trips?",
        answer: "Yes, Rumion vehicles are available for outstation destinations across Maharashtra and neighboring states."
    },
    {
        question: "Is Toyota Rumion suitable for airport transfers?",
        answer: "Yes, Rumion is an excellent option for Pune Airport and Mumbai Airport pickup and drop services."
    },
    {
        question: "Can families book Rumion for vacations?",
        answer: "Yes, Rumion is one of the best choices for family holidays because of its spacious seating and comfortable travel experience."
    },
    {
        question: "Do you provide Rumion for corporate travel?",
        answer: "Yes, Rumion vehicles are available for executive transportation, business meetings, employee travel, and corporate events."
    },
    {
        question: "Can I book a Rumion for one-way travel?",
        answer: "Yes, both one-way and round-trip bookings are available based on travel requirements."
    },
    {
        question: "Is Rumion available for pilgrimage tours?",
        answer: "Yes, Rumion can be hired for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Do you provide pickup from Pune Railway Station and Airport?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Rumion Car Hire in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sameer Kulkarni",
        feedback:
            "We booked a Toyota Rumion for our family trip to Mahabaleshwar. The seating was comfortable, luggage space was excellent, and the journey was enjoyable throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Prajakta Jadhav",
        feedback:
            "Our airport transfer and weekend vacation were perfectly managed with the Rumion. The vehicle was clean, spacious, and ideal for family travel.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Toyota Rumion Car Hire in Pune",
"image": "https://www.risingcabservice.com/assets/images/toyota-rumion-pune.jpg",
"description": "Book Toyota Rumion Car on Rent in Pune with Rising Cab Service for comfortable 6–7 seater family travel, airport transfers, and outstation trips. Ideal for Pune to Mahabaleshwar, Lonavala, and other hill station journeys.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹15/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/rumion-car-hire-in-pune"
}
};







    return (
        <div>

<Helmet>
  <title>Toyota Rumion Car on Rent in Pune | 6–7 Seater Family Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Toyota Rumion Car on Rent in Pune for family trips, airport transfers, and outstation travel. Get 6–7 seater comfortable AC cab for safe journeys."
/>

<meta
 name="keywords"
 content="rumion car on rent in pune, toyota rumion cab pune, rumion car hire pimpri chinchwad, rumion cab service pune, 6 seater car on rent pune, 7 seater rumion pune, pune airport rumion cab, pune to mahabaleshwar rumion taxi, rumion outstation cab pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Rumioncarhire;